import { Configurer } from '../Core/index';
import { Zpfs_s3 } from './Zpfs_s3';

/**Upload service with S3 storage*/
export class Zpfs_s3Configurer extends Configurer {}
